/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../http/http';
import { success, error } from '../../../services/alert-message';

const urlApi = 'search?term=';

/**
 *
 * @param {*} param0
 * @param {*} obj
 */
export async function search({ state, commit }, obj) {
  return (await http.get(`${urlApi}${state.filtros.termo}`)
    .then(res => {
      commit('SET_RESULTADO', res.data);
      return res;
    })
    .catch(err => {
      error(`${err.error.message}`);
      return err;
    })
  ).data;
}
